import { FC, useEffect, useState } from 'react'
import { styled } from '../../../lib/stitches'
import Switch from '../../core/Switch'
import SnapManager from '../selectedcontainer/canvas-piano-roll/SnapManager'

const Flex = styled('div', {
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center'
})

const Label = styled('label', {
  color: '$gray15',
  whiteSpace: 'nowrap',
  fontSize: '14px',
  lineHeight: '24px',
  fontWeight: '$medium',
  paddingRight: '8px'
})

const SnapToggle: FC = () => {
  const [snap, setSnap] = useState(SnapManager.state.snap)
  useEffect(() => {
    SnapManager.subscribe('toggle', ({ snap }) => setSnap(snap))
    return () => SnapManager.unsubscribe('toggle')
  }, [])
  return (
    <Flex>
      <Label htmlFor="toggle">Snap to Grid</Label>
      <Switch
        id="toggle"
        checked={snap}
        onCheckedChange={(value) => SnapManager.update({ ...SnapManager.state, snap: value })}
      />
    </Flex>
  )
}

export default SnapToggle
